// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2Xil4","signatureButtonsRight":"ModalSign_signatureButtonsRight__3b3VR"};